<template>
  <div class="lrb_wrapper">
    <div class="lrb_t">
      <div class="lrb_top_content flex-center">
        <nav class="lrb_nav_top flex-center" ref="navTag">
          <!--                <img src="@/assets/image/logo.png" alt="满电电">-->
          <div class="lrb_nav_logo">满电电</div>
          <ul class="lrb_t_items flex-center">
            <li
              class="lrb_tag_item"
              :class="{ active: index === 0 }"
              @click="backTop"
            >
              <a class="lrb_link lrb_link_home ">首页</a>
            </li>
            <li
              class="lrb_tag_item second_tag"
              :class="{ active: index === 1 }"
              @click="onChange(1)"
            >
              <a class="lrb_link lrb_link_com">公司介绍</a>
            </li>
            <li
              class="lrb_tag_item third_tag"
              :class="{ active: index === 2 }"
              @click="onChange(2)"
            >
              <a class="lrb_link lrb_link_pro">产品介绍</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="lrb_m" id="1" ref="secPage">
      <div class="lrb_company_info">
        <div class="lrb_title_box">公司介绍</div>
        <div class="lrb_info_box">
          深圳满电电投资控股有限公司以“发展软件产业，创新软件科技”为己任以技术和服务为根本，秉承踏实严谨的工作作风，扎根本土，放眼世界，携手合作伙伴共创未来，不断丰富企业文化，继续树立良好的企业社会形象。
        </div>
        <div class="lrb_sec_box">
          <span>经营范围包括：</span>
          供应链管理及相关配套服务；软件开发,信息系统集成服务；电子产品的研发及销售；数据处理服务；电子商务软件及系统的技术开发和技术服务；商务信息咨询；从事广告业务；销售点终端机具的技术开发、上门安装及上门维护；网页设计；国内贸易；经营进出口业务。
        </div>
        <div class="lrb_thr_box">
          <span>围绕核心企业：</span>
          提供行业应用软件产品，实时高效解决众多领域客户的困难；公司重视管理体系和资质建设，已经建立完善的管理体系，取得了齐全、高级别的经营资质,为生产经营和持续发展奠定了良好基础。
        </div>
      </div>
      <div class="lrb_m_img"></div>
    </div>
    <div class="lrb_f" id="2" ref="thrPage">
      <div class="flex-start">
        <div class="lrb_product_info">
          <div class="lrb_title_box">产品介绍</div>
          <img
            src="@/assets/image/lrb_logo.png"
            alt="卡刷刷"
            class="lrb_logo"
          />
          <div class="lrb_title_l">卡刷刷APP</div>
          <div class="lrb_title_a">移动互联网平台</div>
          <div class="lrb_product_desc">
            卡刷刷系统为服务商日常经营决策提供数据支撑服务，从邀请商户/代理、终端机具库存管理、商户经营、收益统计提供全流程科学管理。服务商可通过APP了解本级/下级发展的商户经营情况，并根据经营情况针对性推出营销活动，也可实时查看自已的经营收益。
          </div>
        </div>
        <div class="lrb_p_img"></div>
      </div>
    </div>
    <div class="lrb_foot">
      <div class="lrb_addr">地址：深圳市南山区西丽街道松坪山社区高新北二道19号富裕顶大厦513</div>
      <a href="https://beian.miit.gov.cn/" target="blank" class="beian">
        邮编:518000粤ICP备2020096155号
      </a>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'index',
  data: () => ({
    index: 0,
  }),
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    //离开该页面需要移除这个监听的事件
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    backTop() {
      this.index = 0
      $('body,html').animate({
        scrollTop: 0,
      })
    },
    onChange(index) {
      this.index = parseInt(index)
      if (this.index == 1) {
        $.scrollTo('#1', 300)
      } else {
        $.scrollTo('#2', 500)
      }
    },
    handleScroll() {
      //获取滚动条的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let secTp = this.$refs.secPage.offsetTop
      let thrTp = this.$refs.thrPage.offsetTop
      let navTag = this.$refs.navTag.offsetHeight
      if (scrollTop < secTp - navTag) {
        this.index = 0
      } else {
        if (scrollTop > thrTp - navTag) {
          this.index = 2
        } else {
          this.index = 1
        }
      }
    },
    //获取当前元素的offsetTop
    getOffsetTop(obj) {
      let offsetTop = 0
      while (obj != window.document.body && obj != null) {
        offsetTop += obj.offsetTop
        obj = obj.offsetParent
      }
      return offsetTop
    },
  },
}
</script>

<style scoped></style>
